/**
 * MotoristaTransbordoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {MotoristaTransbordo} from '@/model/resource/MotoristaTransbordo'

/* TODO: review generated class */
@HttpExclude()
export class MotoristaTransbordoCollection extends PageCollection<
  MotoristaTransbordo
> {
  constructor() {
    super(MotoristaTransbordo)
  }

  queryAsPage() {
    return this.listMotoristaTransbordo()
  }

  async listMotoristaTransbordo() {
    return await Request.get(`/admin/motorista-transbordo`, {
      params: this.params,
    })
      .name('listMotoristaTransbordo')
      .as(this)
      .getResponse()
  }

  async listCsvMotoristaTransbordo() {
    return await Request.get(`/admin/motorista-transbordo/csv`, {
      params: this.params,
    })
      .name('listCsvMotoristaTransbordo')
      .as(this)
      .getResponse()
  }
}
